import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doCheckoutOffer),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(watchOfferCheckout);

import { push as updatePath } from 'react-router-redux';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { put, call, fork, takeEvery } from 'redux-saga/effects';
import { promotionByAlias } from 'redux/saga/entities/bound';
import { getMsa } from 'containers/LocationModal/location.saga';
import Base64Deriver from 'derivers/Base64';
var CHECKOUT_OFFER = 'OFFER_CHECKOUT/CHECKOUT_OFFER';
export var checkoutOffer = function checkoutOffer(promotionAlias) {
  return {
    type: CHECKOUT_OFFER,
    promotionAlias: promotionAlias
  };
};
export function doCheckoutOffer(client, _ref) {
  var promotionAlias, _ref2, msaId, _ref3, offers, _offers$reduce, msaOfferId;

  return regeneratorRuntime.wrap(function doCheckoutOffer$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          promotionAlias = _ref.promotionAlias;
          _context.prev = 1;
          _context.next = 4;
          return call(getMsa, client);

        case 4:
          _ref2 = _context.sent;
          msaId = _ref2.id;
          _context.next = 8;
          return call(fetchEntityIfNeeded, promotionByAlias, [client, promotionAlias, msaId]);

        case 8:
          _ref3 = _context.sent;
          offers = _ref3.offers;
          _offers$reduce = offers.reduce(function (bestOffer, currentOffer) {
            return currentOffer.offer.priority < bestOffer.offer.priority ? currentOffer : bestOffer;
          }, offers[0]), msaOfferId = _offers$reduce.id;
          _context.next = 13;
          return put(updatePath("/signup/offer/".concat(Base64Deriver.encode(msaOfferId))));

        case 13:
          _context.next = 17;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](1);

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 15]]);
}
export function watchOfferCheckout(client) {
  return regeneratorRuntime.wrap(function watchOfferCheckout$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fork(takeEvery, CHECKOUT_OFFER, doCheckoutOffer, client);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}